import React, { FC } from 'react'

import { IconCallsContactsProps } from './IconCallsContacts.types'
import * as Styled from './styles/IconCallsContacts.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCallsContacts: FC<IconCallsContactsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCallsContactsProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconCallsContactsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M136 8H24A16 16 0 0 0 8 24v120a16 16 0 0 0 16 16h112a16 16 0 0 0 16-16V24a16 16 0 0 0-16-16zm-8 40h16v32h-16zm0 40h16v32h-16zm16-64v16h-16V16h8a8 8 0 0 1 8 8zM16 144V24a8 8 0 0 1 8-8h96v136H24a8 8 0 0 1-8-8zm120 8h-8v-24h16v16a8 8 0 0 1-8 8z' />
        <path d='M104 119.42C101.53 103 93.47 89.76 83.1 83.66a22 22 0 1 0-26 .13C46.66 90 38.43 103.29 36 119.41a4 4 0 0 0 8 1.18C47.09 99.42 59.81 88 70.18 88 80.39 88 92.92 99.42 96 120.58a4 4 0 0 0 7.91-1.17zM70 52a14 14 0 1 1-14 14 14 14 0 0 1 14-14z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCallsContacts
